module.exports = __webpack_public_path__ + "img/as.5623c5d0.svg";